<div class="l-top-navi" role="navigation" aria-label="Navigation">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <!-- 戻る -->
        <ng-container *ngIf="isDisplay$ | async">
          <div class="l-top-navi__back-area">
            <a
              id="reservation-detail-header-back"
              (click)="onBack()"
              class="l-top-navi__back-link reservation-detail-header-back"
              ><span class="u-visually-hidden">Back to Previous Page</span></a
            >
          </div>
        </ng-container>
        <!-- 提携： 提携サイトに戻る -->
        <ng-container *ngIf="backAllSite">
          <div class="l-top-navi__back-area">
            <button
              id="all-site-link-my-booking"
              class="l-top-navi__back-link reservation-detail-header-back"
              aswAllSiteLink
            >
              <span class="u-visually-hidden">Back to Previous Page</span>
            </button>
          </div>
        </ng-container>
        <!-- 画面タイトル -->
        <ng-container *ngIf="displayTitle$ | async; let displayTitle">
          <div class="l-top-navi__heading-area" id="header-detail-booking">
            <h1 class="l-top-navi__heading-text" [innerHTML]="displayTitle | staticMsg"></h1>
          </div>
        </ng-container>

        <!-- メニュー -->
        <div class="l-top-navi__function-item">
          <asw-button
            type="quaternary"
            class="l-top-navi__function-item--button"
            size="s"
            icon="external"
            [label]="'label.menu' | staticMsg"
            (click$)="openMenuModal()"
          ></asw-button>
        </div>
      </div>
    </div>
  </div>
</div>
